<template>
  <div class="progress-range">
    <label for="period" v-if="label">{{ dataValue }}</label>

    <div class="progress">
      <div class="range-item">
        <input
          type="range"
          class="range-field"
          name="period"
          :min="min"
          :max="max"
          :step="step"
          value="dataValue"
          v-model="dataValue"
        />
      </div>
      <div class="range-fill" :style="{ background: fill }"></div>
      <div v-if="date" class="division">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      <div vv-if="num" class="division">
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      <div v-if="date" class="option">
        <span>1</span>
        <span>6</span>
        <span>12</span>
        <span>18</span>
        <span>24</span>
        <span>30</span>
        <span>36</span>
      </div>
      <div v-if="num" class="option">
        <div class="start">
          <span>0.00</span>
        </div>
        <div class="end">
          <span>51,580.87</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="scss" scoped></style>
<script>
export default {
  name: "Range",
  components: {},
  props: ["label", "value", "min", "max", "step", "date", "num"],

  data() {
    return {
      dataValue: this.value,
    };
  },
  computed: {
    fill() {
      const fill = [];
      fill.push((100 / this.max) * this.dataValue);
      return `linear-gradient(to right, #ffd719 ${fill[0]}%, #f0f0f0 ${fill[0]}%)`;
    },
  },
};
</script>
